import ApiService from '../../../../../../services/ApiService'

export default {
  props: {
    equipmentSelected: Array,
  },

  data: () => ({
    loading: false,
    contractLoading: false,
    error: false,
    firstValid: true,
    errorMessage: '',
    contractId: null,
    contracts: [],
    institutionId: null,
    contractRules: [(v) => !!v || 'Contrato requerido'],
    apiService: new ApiService(),
  }),

  async created() {
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.getContracts()
  },

  components: {},

  methods: {
    close() {
      this.$emit('clearSelection')
      this.$emit('close')
    },

    async getContracts() {
      this.contractLoading = true
      await this.apiService
        .get(`contract/list/${this.institutionId}`)
        .then((response) => {
          this.contracts = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.contractLoading = false
    },

    async submit() {
      this.loading = true
      const equipment = this.equipmentSelected.map((equip) => {
        equip.contractId = this.contractId
        return equip
      })

      if (this.$refs.firstForm.validate()) {
        await this.apiService
          .post('equipment/setContract', equipment)
          .then((response) => {
            this.close()
          })
          .catch((err) => {
            this.errorMessage = err.body.message
            this.error = true

            setTimeout(() => {
              this.error = false
            }, 4000)
          })
      }

      this.loading = false
    },
  },

  watch: {},
}
